{
  "salon-search-container": {
    "text": {
      "find-salon": "Trouvez votre salon",
      "find-salon-hint": "Veuillez sélectionner la ville souhaitée pour le salon"
    }
  }
}
